<template>
    <section>
      <button @click="gtagTest1">Test link 1</button>
      <button @click="gtagTest2">Test link 2</button>
       <button @click="gtagTest3">Test link 3</button>
         <button @click="gtagTest4">Test link 4</button>
       <!-- <form @submit="onSubmit" method="POST" ref="form" id="sendy-form">
            
            <input type="hidden" name="list" value="y3Ep0BGWhxkmrB1763I53pMQ"/>
            <input type="hidden" name="api_key" value="Z0skjz8tyn5VcME6DCmr"/>
            <div id="hp">
                <label for="hp">HP</label>
                <input type="text" name="hp" id="hp">
			</div>
        <div class="sendyInlineWrapper">
                <div class="sendySubmitInline">
                    <input type="email" v-model="email" name="email" placeholder="Enter email address" id="email"/> -->
                    <!-- <button class="btn btn-success">Submit</button> -->
                    <!-- <input type="image" class="animated pulse animated-infinite bounce_button" src="/static/assets/images/Subscribe.png" name="submit" id="submit"/>
                </div>
                <p class="subtitle">You will be entered for a chance to win <span class="sign__word animated tada infinite"> alpha access!</span></p>
        </div>
          
        </form> -->
         <!-- <iframe class="socialwidget" style="border: 1px solid rgb(204, 204, 204); width: 480px; max-width: 100%; box-sizing: border-box; overflow: hidden; height: 481px;" scrolling="no" src="https://widget.socialman.net/234e5dc39dc52740524f9d863bec963c/actions?data_ref=https%3A%2F%2Ft.co%2FMGHcTZCYnq%3Famp%3D1" id="sm_iframe"></iframe>
       <iframe src="https://dwerve.com/embedwidget" width="850" height="400" frameborder="0"></iframe>-->
    </section> 
</template>

<script>
import Footer from "@/views/Home/Footer.vue";
import SendyModal from "@/views/Home/SendyModal.vue";
import SendyInline from "@/views/Home/SendyInline.vue";
import embedWidget from "@/components/embedWidget.vue";
import { mapActions } from 'vuex';
export default {
  data() {
    return {
        email: '',
        description: '',
        output: ''
    };
  },
  components: {
    Footer,
    SendyModal,
    SendyInline,
    embedWidget
  },
 methods: {
       ...mapActions(['gtagTest1','gtagTest2','gtagTest3','gtagTest4']),
    openSendyModal() {
      document.getElementById("mySendyModal").style.display = "block";
    },
    closeSendyModal() {
      document.getElementById("mySendyModal").style.display = "none";

    },
     onSubmit(e) {
        e.preventDefault();
       
         this.$ga.event('Sign Up', 'Suscribe', 'Suscribe Form', 1);
       

      
    },
    onNotConfrimed(e){
          e.preventDefault();
       
    },
     onReSubmit(e){
       e.preventDefault();
       
       var self = this;
       $.ajax({
        type: 'POST',
        url: 'https://mail.halfhumangames.com/subscribe',
        api_key: "Z0skjz8tyn5VcME6DCmr",              
        list: "y3Ep0BGWhxkmrB1763I53pMQ",
        data: $('#sendy-form').serialize(),
        headers: {
            'Content-type': 'application/x-www-form-urlencoded'
            }, 
        boolean: true,
        success: function (data) {
                   self.$alert("A confirmation email has been sent. If you do not see it in your inbox, please check the spam folder.","Thanks for suscribing!",'success');
        }
        
    });
    }

 },
  mounted() {
    //this.readMarkdown();
  }
};
</script>

<style scoped>

nav.navbar {
  top: 0 !important;
}
.portraitWrap img {
  width: 100%;
    position: fixed;
    height: 304px;
    opacity: 0.5;
    top: 65px;
    z-index: -1;
    -o-object-fit: cover;
    object-fit: cover;
}
.ctaImg {
  display: none;
}
#hp{
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/views/Home/TestPage.vue